import React from "react";

import AdminClientHeader from "../components/header/AdminClientHeader";
import "./AdminUserCreateClient.scss";
import AdminForm from "../components/form/AdminForm";
import { withPermission } from "hocs/withPermission";
import { UserRole } from "configs/constants";

const AdminUserCreateAdmin = () => {
  const breadCrumbs = [
    { text: "USERS" },
    { url: "/admin/territories/admins", text: "ADMINS" },
    { text: "NEW" }
  ];
  return (
    <div className="admin-user-create-client admin-create-update-client">
      <AdminClientHeader breadCrumbs={breadCrumbs} hasButton={false} />
      <div className="admin-content form-content">
        <h2 className="title">Create Admin User</h2>
        <AdminForm />
      </div>
    </div>
  );
};
export default withPermission(AdminUserCreateAdmin, [UserRole.ADMIN]);
